export default __webpack_public_path__ + "static/media/icon-eth-small.e8747a8b.svg";